export interface Props {
  value: string;
}

export const Email = ({ value }: Props) => (
  <a className="email" href={`mailto:${value}`}>
    {value}
  </a>
);
